import type { FormValues, NormalizedFormValues } from 'src/app/pages/petitionGamma/details/shared/types';

export function normalizeCaptcha({
	recaptchaResponse,
}: Pick<FormValues, 'recaptchaResponse'>): NormalizedFormValues['recaptchaResponse'] {
	return recaptchaResponse || null;
}
